module.exports = __webpack_public_path__ + "images/emoji/milky_way.f7aadfc0cd4053ad9e00.png";